var IncrementalDOM = require('incremental-dom')
var patch = IncrementalDOM.patch
var elementOpen = IncrementalDOM.elementOpen
var elementClose = IncrementalDOM.elementClose
var skip = IncrementalDOM.skip
var currentElement = IncrementalDOM.currentElement
var text = IncrementalDOM.text

var hoisted1 = ["class", "routes"]
var hoisted2 = ["class", "pad-10"]
var hoisted3 = ["class", "callout callout-info"]
var hoisted4 = ["class", "alert alert-danger"]
var hoisted5 = ["class", "text-danger"]
var hoisted6 = ["class", "text-danger"]
var hoisted7 = ["class", "row"]
var hoisted8 = ["class", "col-md-6"]
var hoisted9 = ["class", "clearfix"]
var hoisted10 = ["class", "input-group input-group-sm pull-right", "style", "width: 180px;"]
var hoisted11 = ["type", "text", "class", "form-control pull-right", "placeholder", "Search"]
var hoisted12 = ["class", "input-group-btn"]
var hoisted13 = ["type", "submit", "class", "btn btn-default"]
var hoisted14 = ["class", "fa fa-search"]
var hoisted15 = ["class", "table table-bordered table-hover"]
var hoisted16 = ["class", "file"]
var hoisted17 = ["class", "clearfix"]
var hoisted18 = ["class", "btn btn-xs btn-primary pull-right"]
var hoisted19 = ["class", "pagination pagination-sm no-margin pull-right hide"]
var hoisted20 = ["href", "#"]
var hoisted21 = ["href", "#"]
var hoisted22 = ["href", "#"]
var hoisted23 = ["href", "#"]
var hoisted24 = ["href", "#"]
var hoisted25 = ["class", "col-md-6"]
var hoisted26 = ["class", "form-horizontal"]
var hoisted27 = ["class", "form-group"]
var hoisted28 = ["for", "method", "class", "col-md-4 control-label"]
var hoisted29 = ["class", "col-md-8"]
var hoisted30 = ["class", "form-control", "id", "method"]
var hoisted31 = ["value", "GET"]
var hoisted32 = ["value", "POST"]
var hoisted33 = ["value", "PUT"]
var hoisted34 = ["value", "DELETE"]
var hoisted35 = ["value", "HEAD"]
var hoisted36 = ["value", "OPTIONS"]
var hoisted37 = ["value", "CONNECT"]
var hoisted38 = ["class", "form-group"]
var hoisted39 = ["for", "path", "class", "col-md-4 control-label"]
var hoisted40 = ["class", "col-md-8"]
var hoisted41 = ["type", "text", "class", "form-control", "id", "path", "placeholder", "Path"]
var hoisted42 = ["class", "form-group"]
var hoisted43 = ["for", "resource-path", "class", "col-md-4 control-label"]
var hoisted44 = ["class", "col-md-8"]
var hoisted45 = ["type", "text", "class", "form-control", "id", "resource-path", "placeholder", "Path"]
var hoisted46 = ["class", "form-group"]
var hoisted47 = ["for", "resource-name", "class", "col-md-4 control-label"]
var hoisted48 = ["class", "col-md-8"]
var hoisted49 = ["type", "text", "class", "form-control", "id", "resource-name", "placeholder", "Name"]
var hoisted50 = ["class", "form-group"]
var hoisted51 = ["for", "description", "class", "col-md-4 control-label"]
var hoisted52 = ["class", "col-md-8"]
var hoisted53 = ["class", "form-control", "id", "description", "placeholder", "Description"]
var hoisted54 = ["class", "form-group"]
var hoisted55 = ["class", "col-sm-offset-4 col-sm-8"]
var hoisted56 = ["type", "checkbox", "id", "ignore"]
var hoisted57 = ["class", "btn btn-xs btn-danger pull-right"]
var __target

module.exports = function description (ctrl) {
  if (ctrl && ctrl.model) {
    elementOpen("div", "8a5ec13e-3983-4b9d-b72f-8fd5b91ccddf", hoisted1)
      var model = ctrl.model
            var routes = ctrl.filtered
      elementOpen("div", "9442a6b2-f3cb-4a7f-beae-63b8162f11ce", hoisted2)
        elementOpen("h4")
          text("" + (model.name) + "")
        elementClose("h4")
        text(" " + (model.description) + " \
              ")
        if (!routes.length) {
          elementOpen("div", "2e70c6ea-9edb-41a1-b694-46fad0a6cbc1", hoisted3)
            elementOpen("h4")
              text("No routes found")
            elementClose("h4")
            if (!model.routes.length) {
              elementOpen("p")
                text("Click `Add Route` to add your first route.")
              elementClose("p")
            }
            if (model.routes.length) {
              elementOpen("p")
                text("Change the search query.")
              elementClose("p")
            }
          elementClose("div")
        }
        if (model.errors.length) {
          elementOpen("div", "634b3429-6a43-46c8-8a1b-fe3f63ab5c6e", hoisted4)
            elementOpen("h4", "f142765c-0ded-455f-a892-2b02562a25f1", hoisted5)
              text("Errors")
            elementClose("h4")
            elementOpen("ul")
              __target = model.errors
              if (__target) {
                ;(__target.forEach ? __target : Object.keys(__target)).forEach(function($value, $item, $target) {
                  var item = $value
                  var $key = "9a3f609d-e89b-4175-ae04-257a37e0d957_" + $item
                  elementOpen("li", $key)
                    elementOpen("a", "1a7edb7a-0ca0-4992-b58f-5054ef82c90a_" + $key, hoisted6, "onclick", function ($event) {
                      var $element = this;
                    ctrl.onClickErrorNode(item)})
                      text("" + (item.error) + "")
                    elementClose("a")
                  elementClose("li")
                }, this)
              }
            elementClose("ul")
          elementClose("div")
        }
        elementOpen("div", "469efb7e-a09d-4019-86c8-377014fdf597", hoisted7)
          elementOpen("div", "52570fa3-3147-40dd-89ca-23df31fbc4b1", hoisted8)
            elementOpen("div", "0fc4644c-c583-44df-9b6d-353f051b29a7", hoisted9)
              elementOpen("div", "d1de9427-d625-43ab-8145-ee3dc950d1b0", hoisted10)
                elementOpen("input", "03f74606-c3d0-4359-a1a5-ef7f380089c0", hoisted11, "value", ctrl.query, "onkeyup", function ($event) {
                  var $element = this;
                ctrl.query = this.value})
                elementClose("input")
                elementOpen("div", "2a669bd1-4e4f-440d-bb34-a7dec14f261a", hoisted12)
                  elementOpen("button", "dc90a9f8-2b9a-49b9-976e-ac524930eb11", hoisted13)
                    elementOpen("i", "c636b121-97ef-4369-ae88-10c7198968dc", hoisted14)
                    elementClose("i")
                  elementClose("button")
                elementClose("div")
              elementClose("div")
            elementClose("div")
            if (routes.length) {
              elementOpen("table", "b1cdc896-9f4d-4797-95ea-f86b08cc6346", hoisted15)
                elementOpen("tbody")
                  __target = routes
                  if (__target) {
                    ;(__target.forEach ? __target : Object.keys(__target)).forEach(function($value, $item, $target) {
                      var route = $value
                      var $key = "c6e2e766-a386-4a81-a559-fbc2b70ce594_" + $item
                      elementOpen("tr", $key, null, "onclick", function ($event) {
                        var $element = this;
                      ctrl.currentRoute = route}, "class", route.getRowClassName(ctrl.currentRoute))
                        elementOpen("td")
                          elementOpen("span", null, null, "class", "label label-" + (route.className) + "")
                            text("" + (route.method) + "")
                          elementClose("span")
                        elementClose("td")
                        elementOpen("td")
                          text("" + (route.path) + "")
                        elementClose("td")
                        elementOpen("td")
                          text("" + (route.description) + "")
                        elementClose("td")
                        elementOpen("td")
                          if (route.resourceDisplay) {
                            elementOpen("a", "f1cdba84-9004-43f4-bc34-0e90f9b8c65b_" + $key, hoisted16, "onclick", function ($event) {
                              var $element = this;
                            ctrl.openRouteResourceFile(route)})
                              text("" + (route.resourceDisplay) + "")
                            elementClose("a")
                          }
                        elementClose("td")
                      elementClose("tr")
                    }, this)
                  }
                elementClose("tbody")
              elementClose("table")
            }
            elementOpen("div", "1d81e5cf-804d-4360-8cdd-0dfd64cb6f09", hoisted17)
              elementOpen("button", "be00f4e6-95c4-41cc-91a8-b8ba20fbfd25", hoisted18, "onclick", function ($event) {
                var $element = this;
              ctrl.addRoute()})
                text("Add")
              elementClose("button")
            elementClose("div")
            elementOpen("ul", "12a26812-3134-40fe-80eb-6e9a7d63d31a", hoisted19)
              elementOpen("li")
                elementOpen("a", "9cdf5323-eccd-4365-b1d1-4c5a6e8250af", hoisted20)
                  text("«")
                elementClose("a")
              elementClose("li")
              elementOpen("li")
                elementOpen("a", "6f6456c0-b796-4775-a63b-27c904e6905e", hoisted21)
                  text("1")
                elementClose("a")
              elementClose("li")
              elementOpen("li")
                elementOpen("a", "85e488f0-37ad-4a8a-819c-7beee89da34f", hoisted22)
                  text("2")
                elementClose("a")
              elementClose("li")
              elementOpen("li")
                elementOpen("a", "dd17ac31-4d93-4fd4-896d-a60c2b261565", hoisted23)
                  text("3")
                elementClose("a")
              elementClose("li")
              elementOpen("li")
                elementOpen("a", "05b8b12c-0845-46c8-b166-2111214eff40", hoisted24)
                  text("»")
                elementClose("a")
              elementClose("li")
            elementClose("ul")
          elementClose("div")
          if (ctrl.currentRoute) {
            elementOpen("div", "b67fd9c5-95c1-47ba-a4e6-59a11d2974f3", hoisted25)
              elementOpen("form", "7e9c1744-228d-4593-b0aa-4ef402a5d026", hoisted26)
                elementOpen("div", "53f8bc39-a245-40c2-a070-c56fadaa205f", hoisted27)
                  elementOpen("label", "76434633-04e2-41ef-928e-6205cb709be9", hoisted28)
                    text("Method")
                  elementClose("label")
                  elementOpen("div", "297fcc45-40de-4107-8311-abec33de8abd", hoisted29)
                    elementOpen("select", "35fe0db2-785f-404b-92d7-bafeb86bee80", hoisted30, "onchange", function ($event) {
                      var $element = this;
                    ctrl.currentRoute.method = this.value})
                      elementOpen("option", "ba3b4598-6ec3-414f-b507-254604071237", hoisted31, "selected", ctrl.currentRoute.method === 'GET' ? 'selected' : null)
                        text("GET")
                      elementClose("option")
                      elementOpen("option", "f9f75e54-ef17-459e-a4b5-3c9b466cd28b", hoisted32, "selected", ctrl.currentRoute.method === 'POST' ? 'selected' : null)
                        text("POST")
                      elementClose("option")
                      elementOpen("option", "c804098e-62ef-4d2a-b54f-a02a95f76b24", hoisted33, "selected", ctrl.currentRoute.method === 'PUT' ? 'selected' : null)
                        text("PUT")
                      elementClose("option")
                      elementOpen("option", "a60e08e2-f6ae-4b7f-abf6-1b28c36ab343", hoisted34, "selected", ctrl.currentRoute.method === 'DELETE' ? 'selected' : null)
                        text("DELETE")
                      elementClose("option")
                      elementOpen("option", "a1af0ea6-158a-474f-b46d-2624be9fd097", hoisted35, "selected", ctrl.currentRoute.method === 'HEAD' ? 'selected' : null)
                        text("HEAD")
                      elementClose("option")
                      elementOpen("option", "a8880aa6-5fb0-4859-bc96-cb8db20b602e", hoisted36, "selected", ctrl.currentRoute.method === 'OPTIONS' ? 'selected' : null)
                        text("OPTIONS")
                      elementClose("option")
                      elementOpen("option", "a03daedb-b144-46a1-b42a-1a118f7fe9eb", hoisted37, "selected", ctrl.currentRoute.method === 'CONNECT' ? 'selected' : null)
                        text("CONNECT")
                      elementClose("option")
                    elementClose("select")
                  elementClose("div")
                elementClose("div")
                elementOpen("div", "63073b25-8989-4577-b213-073bc859e7c1", hoisted38)
                  elementOpen("label", "ff5fb78c-2a3e-4db5-8fde-9ebd95f00f53", hoisted39)
                    text("Path")
                  elementClose("label")
                  elementOpen("div", "c0554969-34be-4bf1-a3a7-d5081ac6c6ed", hoisted40)
                    elementOpen("input", "1598eec0-45e7-442e-967d-872d76e3b5fd", hoisted41, "value", ctrl.currentRoute.path, "onchange", function ($event) {
                      var $element = this;
                    ctrl.currentRoute.path = this.value})
                    elementClose("input")
                  elementClose("div")
                elementClose("div")
                elementOpen("div", "a92c5bc3-b91a-4e99-9864-f86d9f854227", hoisted42)
                  elementOpen("label", "4ce6f667-613b-4724-8236-100729a84d7a", hoisted43)
                    text("Resource path")
                  elementClose("label")
                  elementOpen("div", "39faafda-6046-4ef9-a298-b7ab48fcf84d", hoisted44)
                    elementOpen("input", "83dcc37e-e5d7-4029-aa03-b2d73404e205", hoisted45, "value", ctrl.currentRoute.resource.path, "onchange", function ($event) {
                      var $element = this;
                    ctrl.currentRoute.resource.path = this.value})
                    elementClose("input")
                  elementClose("div")
                elementClose("div")
                elementOpen("div", "9a3412e4-dfa8-4cb7-bff4-d5ded33b286f", hoisted46)
                  elementOpen("label", "c1cf5dda-8475-4e24-b60c-ce62f96873ac", hoisted47)
                    text("Resource name")
                  elementClose("label")
                  elementOpen("div", "aaddc68b-fed6-4757-b3b5-7cf0b2a44fe6", hoisted48)
                    elementOpen("input", "c825fd2c-fd84-42b6-91b4-960e96750da5", hoisted49, "value", ctrl.currentRoute.resource.name, "onchange", function ($event) {
                      var $element = this;
                    ctrl.currentRoute.resource.name = this.value})
                    elementClose("input")
                  elementClose("div")
                elementClose("div")
                elementOpen("div", "b7b74bd1-87f1-4922-9a7a-e06cf06e51b8", hoisted50)
                  elementOpen("label", "aa60fa1f-7309-4042-869f-80a7248f1514", hoisted51)
                    text("Description")
                  elementClose("label")
                  elementOpen("div", "75f06ecd-d05e-408f-8a15-f9a32305175b", hoisted52)
                    elementOpen("textarea", "4ac6dae3-a1c0-4d2c-9444-5ca7df3acc95", hoisted53, "value", ctrl.currentRoute.description, "onchange", function ($event) {
                      var $element = this;
                    ctrl.currentRoute.description = this.value})
                    elementClose("textarea")
                  elementClose("div")
                elementClose("div")
                elementOpen("div", "1149fdc5-26ee-4c07-81a6-395f1d51bbcc", hoisted54)
                  elementOpen("div", "a76d984b-768c-4726-85aa-2b89c525ce76", hoisted55)
                    elementOpen("input", "b846c4c3-97a3-4dee-b27a-d8f7cc11c889", hoisted56, "checked", ctrl.currentRoute.ignore, "onchange", function ($event) {
                      var $element = this;
                    ctrl.currentRoute.ignore = this.checked})
                    elementClose("input")
                    text(" Ignore \
                                  ")
                  elementClose("div")
                elementClose("div")
              elementClose("form")
              elementOpen("button", "cd151eeb-0664-43c6-ba92-351d9c0b3c3a", hoisted57, "onclick", function ($event) {
                var $element = this;
              ctrl.removeRoute(ctrl.currentRoute)})
                text("Delete route")
              elementClose("button")
            elementClose("div")
          }
        elementClose("div")
      elementClose("div")
    elementClose("div")
  }
}
